import { HugeiconsIcon } from '@hugeicons/react';
import {
  CancelIcon, CheckmarkBadge01Icon,
  Loading01FreeIcons,
  Loading02FreeIcons,
  SendToMobile02FreeIcons,
  Sent02Icon
} from '@hugeicons/core-free-icons';
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { usePendingNotificationsStore } from '../../stores/pendingNotificationsStore';
import { apiClient } from '../../utils/openApiClient';

const PendingNotificationAlert = () => {
  const { pendingNotifications } = usePendingNotificationsStore(state => state);
  return (
    <div className={'fixed bottom-5 right-5 z-50 flex flex-col gap-2'}>
      <AnimatePresence>
        {pendingNotifications.map((notificationId) => (
          <Card key={notificationId} notificationId={notificationId} />
        ))}
      </AnimatePresence>
    </div>
  );
};

export default PendingNotificationAlert;

function Card({ notificationId }: { notificationId: string }) {
  const [isSent, setIsSent] = useState(false);
  const { removePendingNotification } = usePendingNotificationsStore(state => state);

  useEffect(() => {
    // Check notification status every 5 seconds
    const statusInterval = setInterval(async () => {
      if (isSent) return;

      try {
        // TODO: Replace with your actual API call to check notification status

        const response = await apiClient.GET('/shop/notifications/{id}', { params: { path: { id: notificationId } } });

        if (response?.data?.status !== 'pending') {
          setIsSent(true);

          // Show sent state for 3 seconds then remove
          setTimeout(() => {
            removePendingNotification(notificationId);
          }, 1000);
        }

      } catch (error) {
        console.error('Failed to check notification status:', error);
      }
    }, 3000);

    return () => clearInterval(statusInterval);
  }, [notificationId, isSent, removePendingNotification]);

  const handleClose = () => {
    removePendingNotification(notificationId);
  };

  return (
    <motion.div layout initial={{ x: 200, opacity: 0, width: 230 }} exit={{ x: 200, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                className={`rounded-2xl relative p-4 flex items-center gap-2 ${isSent ? 'text-emerald-500 bg-emerald-100' : 'text-indigo-500 bg-indigo-100'}  z-50  group`}>
      <button onClick={handleClose}
              className={'absolute -top-1 -right-1 p-1 rounded-full group-hover:block bg-indigo-300 text-white hidden'}>
        <HugeiconsIcon size={16} icon={CancelIcon} className={''} />
      </button>
      {isSent ? <HugeiconsIcon icon={CheckmarkBadge01Icon} /> :
        <HugeiconsIcon icon={Sent02Icon} className={'animate-bounce'} />}
      <p>
        {isSent ? 'Notifica inviata' : 'Invio notifica in corso...'}
      </p>
    </motion.div>
  );
}
